import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_unit_of_competency",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "unit_of_competency",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_unit_of_competency_button",
  "data-kt-drawer-close": "#kt_drawer_unit_of_competency_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_unit_of_competency",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_unit_of_competency_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Unit Of Competency </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_unit_of_competency_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_unit_of_competency_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_unit_of_competency_body",
  "data-kt-scroll-dependencies": "#kt_unit_of_competency_header, #kt_unit_of_competency_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_unit_of_competency_scroll"
}
const _hoisted_8 = { class: "table" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, null, -1)
const _hoisted_10 = {
  style: {"border-width":"0px !important"},
  class: "row d-flex"
}
const _hoisted_11 = { class: "col-1 text-start" }
const _hoisted_12 = { class: "col-9" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "col-2 text-end" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus text-light" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  class: "py-5 text-center",
  id: "kt_unit_of_competency_footer"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_unit_of_competency_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_21 = ["data-kt-indicator"]
const _hoisted_22 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_23 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_24 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unit_of_competency, (data, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(index + 1), 1),
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives(_createElementVNode("input", {
                                style: {"display":"block","padding":"0.75rem 1rem","font-size":"1.1rem","font-weight":"500","line-height":"1.5","color":"#181c32","background-color":"#ffffff","background-clip":"padding-box","border":"1px solid #13ad66","-webkit-appearance":"none","-moz-appearance":"none","appearance":"none","border-radius":"0.475rem","box-shadow":"inset 0 1px 2px rgb(0 0 0 / 8%)","transition":"border-color 0.15s ease-in-out,\r\n                                box-shadow 0.15s ease-in-out"},
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.unit_of_competency[index].unit_name) = $event),
                                name: "unit_of_competency",
                                class: "form-control form-control-sm"
                              }, null, 8, _hoisted_13), [
                                [_vModelText, _ctx.unit_of_competency[index].unit_name]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", null, [
                                (index < 1)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUnitOfCompetency())),
                                      class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                    }, _hoisted_16))
                                  : _createCommentVNode("", true),
                                (index >= 1)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeUnitOfCompetency && _ctx.removeUnitOfCompetency(...args))),
                                      class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                    }, _hoisted_18))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_23, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_25
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_21)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])
  ]))
}